// extracted by mini-css-extract-plugin
module.exports = {"sections_divider":"_section-divider_sections_divider__YICSq"};